import { useGetNflTopPlayersQuery } from "../store/api/nflApi";

export const useNflTopPlayers = (category = "passing-yards", leagueScope) => {
  const { data, isLoading, error } = useGetNflTopPlayersQuery({
    category,
    leagueScope,
  });

  return {
    topPlayers: data?.players || [],
    lastUpdated: data?.lastUpdated || null,
    isLoading,
    error,
  };
};
